<template>
  <v-container fluid style="background: linear-gradient(#043339, #D9D9D9, #052947); min-height: 100vh;" class="mt-n16">
    <!-- DESKTOP -->
    <v-container class="d-none d-lg-block" v-if="ready">
      <div class="triangle"></div>
      <div class="green-triangle"></div>
      <div class="gray-triangle"></div>
      <div class="orange-triangle2"></div>
      <div class="beje-triangle"></div>

      <v-row class="py-16">
        <v-col cols="12" class="px-16 ma-0 pa-0">
          <v-card class="elevation-0 px-16 transparent">
            <v-card-title>
              <v-btn
                rounded
                class="text-accent"
                style="float: left; background-color: rgba(255, 255, 255, 0.7);"
                @click="goBack"
              >
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                {{ t('blog.back') }}
              </v-btn>
            </v-card-title>

            <!-- Imagem -->
            <v-col cols="12">
              <v-img
                max-height="600px"
                class="align-center"
                aspect-ratio="16/9"
                style="margin: auto;"
                :src="heroImgSrc"
                :alt="article.value?.title || ''"
              />
            </v-col>

            <!-- Título e subtítulo -->
            <v-card-title
              class="text-h3 font-weight-bold text-uppercase text-left"
              style="white-space: pre-wrap; word-break: keep-all; color:#052947;"
            >
              {{ article.value?.title || '' }}
            </v-card-title>
            <v-card-subtitle class="text-h4 text-left" style="color:#052947;">
              {{ article.value?.subtitle || '' }}
            </v-card-subtitle>

            <!-- Corpo -->
            <v-card-text
              class="text-justify font-weight-medium mt-12 transparent"
              style="background-color: #fff; font-size: 18px; color:#052947;"
            >
              <v-container fluid class="pa-10 paper" v-html="articleBodyHtml" />
            </v-card-text>

            <!-- Autor -->
            <!-- DESKTOP: bloco do autor -->
            <v-card-subtitle class="text-caption">
              <v-divider color="white"></v-divider>
              <div class="mt-8 mb-16">
                <v-row class="ml-2" align="center">
                  <v-col cols="auto" class="ma-0 pa-0">
                    <v-avatar>
                      <v-img cover :src="autorImgSrc" :alt="article?.autor || ''" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="auto" class="ma-0 pa-0">
                    <div>
                      <span class="font-weight-bold ml-2"
                            style="color:#052947">
                        <template v-if="article?.autor || article?.data">
                          ({{ article?.autor || '' }}<template v-if="article?.autor && article?.data"> - </template>{{ article?.data || '' }})
                        </template>
                      </span>
                      <br />
                      <gb-social-button
                        v-if="article.value?.author_id"
                        @click="openSocialNetwork('linkedin', getSocialNetwork(article.value.author_id, 'Linkedin'))"
                        network="linkedin"
                        size="small"
                        :reverse="true"
                        theme="light"
                        style="border: none;"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-subtitle>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- MOBILE -->
    <v-container class="d-md-none" v-if="ready">
      <v-row class="py-16">
        <v-col cols="12" class="ma-0 pa-0">
          <v-card class="elevation-0 transparent">
            <v-card-title>
              <v-btn
                rounded
                class="text-accent"
                style="float: right; background-color: rgba(255, 255, 255, 0.7);"
                @click="goBack"
              >
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                {{ t('blog.back') }}
              </v-btn>
            </v-card-title>

            <!-- Imagem -->
            <v-col cols="12">
              <v-img
                max-height="600px"
                class="align-center"
                aspect-ratio="16/9"
                style="margin: auto;"
                :src="heroImgSrc"
                :alt="article.value?.title || ''"
                cover
              />
            </v-col>

            <!-- Título e subtítulo -->
            <v-card-title
              class="text-h5 font-weight-bold text-uppercase"
              style="white-space: pre-wrap; word-break: keep-all; color:#052947;"
            >
              {{ article.value?.title || '' }}
            </v-card-title>
            <v-card-subtitle class="text-h6" style="color:#052947;">
              {{ article.value?.subtitle || '' }}
            </v-card-subtitle>

            <!-- Corpo -->
            <v-card-text class="text-justify font-weight-medium text-body-1 mt-12" style="color:#052947;">
              <v-container fluid class="pa-10 paper" v-html="articleBodyHtml" />
            </v-card-text>

            <!-- Autor -->
            <!-- MOBILE: bloco do autor -->
            <v-card-subtitle class="text-caption">
              <v-divider></v-divider>
              <div class="mt-8">
                <v-row class="ma-0 pa-0" justify="center">
                  <v-col cols="10" class="ma-0 pa-0">
                    <v-avatar style="margin: auto; display: block;">
                      <v-img cover :src="autorImgSrc" :alt="article.value?.autor || ''" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10" class="text-center mt-2">
                    <span class="font-weight-bold ml-2"
                          style="color:#052947">
                      <template v-if="article?.autor || article?.data">
                        ({{ article?.autor || '' }}<template v-if="article?.autor && article?.data"> - </template>{{ article?.data || '' }})
                      </template>
                    </span>
                    <br />
                    <gb-social-button
                      v-if="article.value?.author_id"
                      @click="openSocialNetwork('linkedin', getSocialNetwork(article.value.author_id, 'Linkedin'))"
                      network="linkedin"
                      size="small"
                      :reverse="true"
                      theme="light"
                      style="border: none; margin: auto; display: block;"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card-subtitle>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- fallback -->
    <v-container v-else class="py-16">
      <v-alert type="warning" variant="tonal">Artigo não encontrado.</v-alert>
    </v-container>
  </v-container>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import ARTICLES from '@/json_articles/articles.json'

const { t, locale } = useI18n({ useScope: 'global' })
const route = useRoute()
const router = useRouter()

const loading = ref(true)
const article = ref(null)
const ready = computed(() => !loading.value && !!article.value)

// ---- webpack dynamic requires (sem Vite) ----
let authorCtx = null
let imagesCtx = null
try {
  authorCtx = require.context('@/json_articles/autores', false, /\.(png|jpe?g|gif|svg)$/)
} catch (e) { /* ok: pode estar no /public */ }
try {
  imagesCtx = require.context('@/json_articles/images', true, /\.(png|jpe?g|gif|svg)$/)
} catch (e) { /* ok: pode estar no /public */ }

// util: primeiro valor “truthy” de uma lista
const pick = (...vals) => vals.find(v => v !== undefined && v !== null && String(v).trim() !== '')

// IMAGEM DO AUTOR
const autorImgSrc = computed(() => {
  if (!article.value) return ''
  const file = pick(article.value.autor_photo, article.value.author_photo, article.value.foto_autor, article.value.authorPhoto)
  if (!file) return ''
  // tenta via webpack (assets)
  if (authorCtx) {
    try { return authorCtx('./' + file) } catch { /* fallthrough */ }
  }
  // fallback para /public
  return `/json_articles/autores/${file}`
})

// IMAGEM PRINCIPAL
const heroImgSrc = computed(() => {
  if (!article.value) return ''
  const id = String(article.value.id || '').trim()
  const foto = String(pick(article.value.foto, article.value.image, article.value.hero) || '').trim()
  if (!id || !foto) return ''
  if (imagesCtx) {
    try { return imagesCtx(`./${id}/${foto}`) } catch { /* fallthrough */ }
  }
  return `/json_articles/images/${id}/${foto}`
})

// BODY (HTML ou texto com \n)
const articleBodyHtml = computed(() => {
  if (!article.value) return ''
  const raw = pick(article.value.body, article.value.content, article.value.texto, article.value.text, '')
  const str = String(raw)
  const seemsHtml = /<\/?[a-z][\s\S]*>/i.test(str)
  return seemsHtml ? str : str.replace(/\n/g, '<br>')
})

// helpers sociais
function getSocialNetwork (authorId, networkName) {
  return typeof window !== 'undefined' && typeof window.$getSocialNetwork === 'function'
    ? window.$getSocialNetwork(authorId, networkName)
    : ''
}
function openSocialNetwork (social, link) {
  if (social === 'linkedin' && link) window.open(link, '_blank')
}
function goBack () {
  router.push(`/${String(locale.value)}/blog`)
}

// normaliza 1 artigo (junta bloco base + bloco do idioma)
function normalizeArticle (baseObj, langObj) {
  const a = { ...(langObj || {}), ...(baseObj || {}) } // o do idioma tem prioridade, depois base
  return {
    id: String(pick(langObj?.id, baseObj?.id, '') || ''),
    title: pick(langObj?.title, langObj?.titulo, baseObj?.title, baseObj?.titulo, ''),
    subtitle: pick(langObj?.subtitle, langObj?.subtitulo, baseObj?.subtitle, baseObj?.subtitulo, ''),
    foto: pick(langObj?.foto, langObj?.image, baseObj?.foto, baseObj?.image, ''),
    autor: pick(langObj?.autor, langObj?.author, baseObj?.autor, baseObj?.author, baseObj?.author_name, ''),
    autor_photo: pick(langObj?.autor_photo, langObj?.author_photo, baseObj?.autor_photo, baseObj?.author_photo, baseObj?.foto_autor, baseObj?.authorPhoto, ''),
    data: pick(langObj?.data, langObj?.date, baseObj?.data, baseObj?.date, ''),
    author_id: pick(langObj?.author_id, baseObj?.author_id),
    body: pick(langObj?.body, langObj?.content, langObj?.texto, baseObj?.body, baseObj?.content, baseObj?.texto, '')
  }
}

// carrega artigo por id (aceita id no bloco do idioma OU no bloco base)
function fillData () {
  loading.value = true
  const idParam = String(route.params.id || '')
  const lang = String(locale.value || 'pt')

  let foundPair = null
  for (const a of (ARTICLES.articles || [])) {
    const langObj = a?.[lang]
    const langId = langObj?.id != null ? String(langObj.id) : null
    const baseId = a?.id != null ? String(a.id) : null
    if (idParam && (idParam === langId || idParam === baseId)) {
      foundPair = { base: a, lang: langObj }
      break
    }
  }

  if (foundPair) {
    article.value = normalizeArticle(foundPair.base, foundPair.lang)
  } else {
    article.value = null
  }
  loading.value = false
}

onMounted(() => {
  fillData()
  if (typeof window !== 'undefined') window.scrollTo(0, 0)
})
watch(() => locale.value, () => fillData(), { immediate: false })
watch(() => route.params.id, () => fillData())
</script>

<style>
.triangle {
  width: 0; height: 0;
  border: 350px solid transparent;
  border-top: 0;
  border-bottom: 600px solid #E98459;
  position: absolute;
  left: -15vh; margin-top: 0; z-index: 0;
}
.paper {
  background: #fff;
  box-shadow:
    0 -1px 1px rgba(0,0,0,0.15),
    0 -10px 0 -5px #eee,
    0 -10px 1px -4px rgba(0,0,0,0.15),
    0 -20px 0 -10px #eee,
    0 -20px 1px -9px rgba(0,0,0,0.15);
  padding: 30px;
}
.green-triangle {
  width: 0; height: 0;
  border: 50px solid transparent;
  border-top: 0;
  border-bottom: 120px solid #0A4E56;
  position: absolute; rotate: -110deg; left: 90%; top: 30%; z-index: 1;
}
.beje-triangle {
  width: 0; height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #EAEAE9;
  position: absolute; rotate: 110deg; left: 0; top: 75%; z-index: 1;
}
.gray-triangle {
  width: 0; height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #858585;
  position: absolute; rotate: 60deg; left: 90%; margin-top: 10vh; z-index: 1;
}
.orange-triangle2 {
  width: 0; height: 0;
  border: 30px solid transparent;
  border-top: 0;
  border-bottom: 80px solid #E76012;
  position: absolute; rotate: 15deg; left: 10%; top: 50%; z-index: 1;
}
</style>
